import React, { Component, Fragment } from 'react';
import { cloneDeep, iteratee } from 'lodash';
import { Col, Form, Input, Modal, Radio, Row, Select, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';
import API from "../scripts/api";

class CityForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: [],
            countries: []
        };

        this.formRef = React.createRef();
    }

    handleCategory = () => {
        this.formRef.current.setFieldsValue({ subCategory: undefined });
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            this.props.onSubmit(values);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount =async (data = {}) => {
        const cloneData = cloneDeep(data);
        await this.getCountries()

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id });
    }

    getCountries = (params = {}) => {
        this.setState({ loading: true });
    
        API.country
          .list(params)
          .then((result) => {
            if (result.data) {
              this.setState({
                loading: false,
                countries: result.data,
              });
            } else {
              this.setState({ loading: false });
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      };
    render() {
        const { categories, onCancel, submitting, tags, visible } = this.props;
        const { fileList, editMode, countries } = this.state;

        const props = {
            onRemove: file => {
                this.setState({ fileList: [] });
            },
            beforeUpload: file => {
                this.setState({ fileList: [file] });
                return false;
            },
            showUploadList: {
                showRemoveIcon: editMode
            },
            fileList
        };

        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}>
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                      
                       <Col xs={24} md={12}>
                            <Form.Item
                                name="country_id"
                                label={Resources.country}
                            >
                                <Select placeholder={Resources.choose}>
                                    <Select.Option > </Select.Option>
                                    {countries && countries.length && countries.map(country => {
                                        // <Select.Option value={country.id} > {country.name} </Select.Option>
                                        return (
                                            <Select.Option key={country.id} value={country.id}>
                                            {country.name}
                                            </Select.Option>
                                        );
                                    })}
                                    
                                </Select>
                            </Form.Item>
                        </Col>
                       
                        <Col xs={24}>
                            <Form.Item name="name" label={Resources.title} rules={Rules.required}>
                                <Input></Input>
                            </Form.Item>
                        </Col>


                    </Row>
                </Form>
            </Modal>
        );
    }
};

export default CityForm;